<template>
    <div>
        <inform></inform>
        <router-link to="/task">Go Back to Study</router-link>
    </div>
</template>
<script>
import Inform from '../Function/InformedConsent.vue';

export default {
  data() {
    return {
    };
  },
  components: {
    inform: Inform,
  },
};
</script>
